import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultSendLocalList } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';

import { LogItemWrapper } from './log-item-wrapper.component';

export const SendLocalListLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultSendLocalList(log.message)) {
    Logger.error(
      'Message is not of type OcppLogCallResultMessageSendLocalList',
      { log },
    );
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack direction="column" gap={GapEnum.S}>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-send-local-list-message-request.identity',
            )}
          </Text>{' '}
          {log.message.parameters.identity ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-send-local-list-message-request.updateType',
            )}
          </Text>{' '}
          {log.message.parameters.updateType ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-send-local-list-message-request.list-version',
            )}
          </Text>{' '}
          {log.message.parameters.listVersion ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-send-local-list-message-request.status',
            )}
          </Text>{' '}
          {log.message.result.status ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S} direction="column">
          {log.message.parameters.localAuthorizationList?.map((local) => (
            <Stack key={local.idTag} gap={GapEnum.S}>
              <Text bold>
                {t(
                  'delmonicos-shared-sdk.ocpp-api-models-send-local-list-message-request.id-tag',
                )}
              </Text>
              {local.idTag} -{' '}
              <Text bold>
                {t(
                  'delmonicos-shared-sdk.ocpp-api-models-send-local-list-message-request.id-tag-info-status',
                )}
              </Text>
              {local.idTagInfo?.status}
            </Stack>
          )) ?? '-'}
        </Stack>
      </Stack>
    </LogItemWrapper>
  );
};
